export function Footer() {
  return (
    <footer className="border-t border-gray-200 py-8 px-6">
      <div className="max-w-6xl mx-auto text-center text-gray-400 text-sm">
        &copy; {new Date().getFullYear()} Cobble. All rights reserved.
      </div>
    </footer>
  );
}
